import { Component, OnInit, Output,Input, EventEmitter  } from '@angular/core';
import { LeftBarType } from '../../comm/class/leftbarjson';
import { Dep } from '../../comm/class/auth';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-main-sidebar',
  templateUrl: './main-sidebar.component.html',
  styleUrls: ['./main-sidebar.component.css']
})

export class MainSidebarComponent implements OnInit {

    //0 arr  1 文字  2radio
    loading:boolean=true;
    now:number = -1;
    power:number;
    list : LeftBarType = [];
	isDesktop: boolean; 

    @Input() user: any;
    @Output() notify = new EventEmitter<any>();
    constructor(private route: ActivatedRoute,public httpClient: HttpClient,) { }

  menu_hit(id: number) {
    if (!id || id >= 9990) { return; } // 9997/9998 為前端注入的假選單，無對應 admin_menu 列
    this.httpClient.post<any>("/customer_service/menu_hit.php", { id }).subscribe(() => {}, () => {}); // fire-and-forget，錯了也不擋導航
  }


    menu_open(item){
        this.list.map((obj, index) => {
            if( obj.id==item.id){
                obj.active = true;
            }else{
                obj.active = false;
            }
      
            return obj;
        });
    }


    ngOnInit(): void {
        this.init_list();  
        this.power = Dep.auth.power_id;
		this.checkDeviceType();
		window.addEventListener('resize', () => {
			this.checkDeviceType();
		});
    }

    init_list(){
        this.loading = true;
        const body = {};
        this.httpClient.post<any>("/customer_service/get_menu_list.php",body).subscribe(res => {
            this.loading = false;
            this.list = res.data;

            // 注入「高風險流失價值用戶」到數據分析群組
            const newItem = { id: 9998, item: '高風險流失價值用戶', active: false, type: 0, url: 'high_risk_churn', power: 0 };
            const targetGroup = this.list.find(g => g.item && g.item.indexOf('數據') !== -1);
            if (targetGroup && !targetGroup.subitem.find((s: any) => s.url === 'high_risk_churn')) {
                targetGroup.subitem.push(newItem);
            }

            // 注入「員工權限管理」到設定群組，僅老闆(5)/工程師(6)可見（後端 API 另有硬驗，此處只控體驗）
            if ([5, 6].includes(Number(this.power))) {
                const empItem = { id: 9997, item: '員工權限管理', active: false, type: 0, url: 'employee-auth', power: 0 };
                const settingGroup = this.list.find(g => g.item && g.item.indexOf('設定') !== -1);
                if (settingGroup && !settingGroup.subitem.find((s: any) => s.url === 'employee-auth')) {
                    settingGroup.subitem.push(empItem);
                }
            }

            // 「使用者稱號設定」改由 admin_menu 供應（url = manualtitle），不再於此注入。
            //   前端注入的假選單（id >= 9990）會繞過 get_menu_list.php 依 admin_role.menu_restrictions
            //   做的過濾，被限制的角色照樣看得到；改吃 DB 才有權限控管，menu_hit 的點擊統計也才會累加。

            let urlname = location.pathname;
            for(let i in this.list){
                let item = this.list[i].subitem;
                for(let a in item){
                    if(urlname.indexOf(item[a].url)!=-1){
                        this.list[i].active = true;
                        this.now = item[a].id;
                    }
                }
            }

        }, error => {
            console.log(error);
        });
    }

	checkDeviceType() {
        if (window.innerWidth > 768) { // 假設768px是切換點
            this.isDesktop = true;
        } else {
            this.isDesktop = false;
        }
    }
}
